import { Component, Input } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { DefectType } from '../model/defect-type.model';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatLabel } from '@angular/material/form-field';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';

@Component({
  selector: 'sibat-defect-type-radio-button',
  template: `
    <div *transloco="let t; read: 'building.control.editDefectForm'" class="defect-type" [formGroup]="group">
      <mat-label [class.warn]="!group?.value.type">{{ t('defectType') }}</mat-label>
      <mat-radio-group formControlName="type" name="defectTypeGroup">
        <mat-radio-button name="defectType" [value]="defectTypes.minor">{{ t('minorDefect') }}</mat-radio-button>
        <mat-radio-button name="defectType" [value]="defectTypes.major">{{ t('majorDefect') }}</mat-radio-button>
      </mat-radio-group>
    </div>
  `,
  styleUrls: ['defect-type-radio-button.component.scss'],
  imports: [TranslocoDirective, ReactiveFormsModule, MatLabel, MatRadioGroup, MatRadioButton],
})
export class DefectTypeRadioButtonComponent {
  @Input() group: UntypedFormGroup;

  defectTypes = DefectType;
}
